import { Box, Tabs } from '@tempmee/react';
import { CandidateStatus, CandidateStatusMapper } from '~/domain/PermanentJobs';
import { useEnablePermanentJobMMFeature } from '~/hooks';
import { Colors } from '~/themes/colors';

type TShowAbleCandidateStatus = Exclude<CandidateStatus, CandidateStatus.Cancelled>;

interface ICandidateStatusFilterPanelProps {
  counts: Record<TShowAbleCandidateStatus, number> & { all: number };
  onChange(tab: CandidateStatus | 'all'): void;
}

const MM_TABS = [CandidateStatus.Rejected, CandidateStatus.Hired] as const;
const V1_TABS = [
  CandidateStatus.Applied,
  CandidateStatus.Scheduled,
  CandidateStatus.Interviewed,
  CandidateStatus.Rejected,
  CandidateStatus.Hired,
];

export const CandidateStatusFilterPanel = ({
  counts,
  onChange,
}: ICandidateStatusFilterPanelProps) => {
  const { isEnablePermanentJobMM } = useEnablePermanentJobMMFeature();

  const countInProgress =
    counts.app_expired + counts.applied + counts.interviewed + counts.new + counts.scheduled;

  if (isEnablePermanentJobMM) {
    return (
      <Tabs
        defaultValue="all"
        onValueChange={(value) => onChange(value === 'all' ? 'all' : (value as CandidateStatus))}
        style={{ alignItems: 'flex-start' }}
      >
        <Tabs.List style={{ gap: 16, marginBottom: 8 }}>
          <Tabs.Tab value="all">
            <Box
              height="10px"
              width="10px"
              className="rounded-full"
              style={{ display: 'inline-block', marginRight: 6, backgroundColor: Colors.secondary_500 }}
            />
            {`In Progress${countInProgress > 0 ? ` (${countInProgress})` : ''}`}
          </Tabs.Tab>
          {MM_TABS.map((it) => (
            <Tabs.Tab key={it} value={it}>
              <Box
                height="10px"
                width="10px"
                className="rounded-full"
                style={{
                  display: 'inline-block',
                  marginRight: 6,
                  backgroundColor: CandidateStatusMapper.getColor(it),
                }}
              />
              {`${CandidateStatusMapper.toHumanReadable(it)}${counts[it] > 0 ? ` (${counts[it]})` : ''}`}
            </Tabs.Tab>
          ))}
        </Tabs.List>
      </Tabs>
    );
  }

  return (
    <Tabs
      defaultValue="all"
      onValueChange={(value) => onChange(value === 'all' ? 'all' : (value as CandidateStatus))}
      style={{ alignItems: 'flex-start' }}
    >
      <Tabs.List style={{ gap: 16, marginBottom: 8 }}>
        <Tabs.Tab value="all">
          {`All${counts.all > 0 ? ` (${counts.all})` : ''}`}
        </Tabs.Tab>
        {V1_TABS.map((it) => (
          <Tabs.Tab key={it} value={it}>
            <Box
              height="10px"
              width="10px"
              className="rounded-full"
              style={{
                display: 'inline-block',
                marginRight: 6,
                backgroundColor: CandidateStatusMapper.getColor(it),
              }}
            />
            {`${CandidateStatusMapper.toHumanReadable(it)}${counts[it as TShowAbleCandidateStatus] > 0 ? ` (${counts[it as TShowAbleCandidateStatus]})` : ''}`}
          </Tabs.Tab>
        ))}
      </Tabs.List>
    </Tabs>
  );
};
